// 日语
export default {
  Login: {
    Title: "アカウントにログイン",
    describe: "ログインするか、アカウントを作成して開始してください。",
    Google: "Googleで続行",
    Apple: "Appleで続行",
    or: "または",
    Emailplaceholder: "メールアドレス",
    Passwordplaceholder: "パスワード",
    Login: "ログイン",
    forgot: "パスワードをお忘れですか？",
    notAccount: "Fineshareアカウントをお持ちでないですか？",
    Signup: "サインアップ",
    InvalidEmail: "無効なメール形式です。",
    InvalidPassword: "パスワードは6文字以上である必要があります。",
    loading: "読み込み中...",
    login: "ログイン",
    errorText:
      "ログインに失敗しました。ユーザー名とパスワードを確認してください。",
  },
  signup: {
    Title: "アカウントを作成",
    describe: "数秒でFineshareアカウントを作成します。",
    Google: "Googleでサインアップ",
    Apple: "Appleでサインアップ",
    or: "または",
    Emailplaceholder: "メールアドレスを入力",
    Passwordplaceholder: "6桁のパスワードを入力",
    Already: "すでにアカウントをお持ちですか？",
    Login: "ログイン",
    By: "アカウントを作成することで、私は以下に同意したことになります",
    Privacy: "プライバシーポリシー",
    Terms: "利用規約",
    and: "および",
    signupText: "アカウントを作成",
    InvalidEmail: "無効なメール形式です。",
    InvalidPassword: "パスワードは6文字以上である必要があります。",
    loading: "読み込み中...",
    passwordError: "このメールアドレスはすでに登録されています",
    again: "リクエストが多すぎます。後でもう一度お試しください。",
    Registration:
      "登録に失敗しました。メールアドレスとパスワードを確認してください。",
    hasRegistered: "このメールアドレスはすでに登録されています",
    Title2: "Fineshareアカウントを作成",
  },
  Home: {
    Welcome: "Fineshare アカウントセンターへようこそ",
    Hi: "こんにちは、",
    Order: "私の注文",
    orders: "購入注文を確認",
    Learn: "もっと知る",
    Product: "製品管理",
    products: "購入した製品を見る",
    Setting: "アカウント設定",
    Settings: "アカウントの詳細とパスワードの変更",
    account: "アカウントを最大限に活用しましょう",
    FineCam: "FineCam",
    FineCams: "どこでもインスピレーションビデオを作成・共有",
    FineVoice: "FineVoice",
    FineVoices: "お気に入りの声でボイスオーバーを作成、あなたの方法で",
    VoiceTrans: "VoiceTrans",
    VoiceTranss: "声を変え、感情を伝えよう",
    Singify: "Singify",
    Singifys: "希望の声でAIカバーを作成",
  },
  success: {
    Congratulations: "おめでとうございます！",
    successfully: "Fineshareアカウントが正常に作成されました。",
  },
  successapp: {
    Successful: "ログイン成功！",
    successfully1:
      "Fineshareアカウントに正常にログインしました。これからアプリを使用できます。",
    successfully2:
      "Fineshareアカウントに正常にログインしました。今すぐこのウィンドウを閉じてアプリを使用開始できます。",
    Go: "Fineshareユーザーセンターへ移動",
  },
  forgot: {
    ForgotPas: "パスワードを忘れましたか？",
    Enter1: "パスワードリセット用のメールアドレスを入力してください",
    Enter2:
      "メールアドレスを入力していただくと、パスワードリセットリンクをお送りします。",
    exmple: "{email}",
    Back: "ログインに戻る",
    submitText: "送信",
    errorText: "メールアドレスを入力してください",
    loading: "読み込み中...",
    sent: "メールアドレスにメールを送信しました",
    notExist:
      "このメールアドレスは存在しません。メールアドレスを確認してください。",
    Reset: "リセットに失敗しました。メールアドレスを確認してください。",
  },
  account: {
    Settings: "アカウント設定",
    Change: "アカウントの詳細、パスワードなどを変更します。",
    Personal: "個人情報",
    email: "Eメール：",
    Name: "ユーザー名：",
    Edit: "編集",
    title: "ユーザー名を変更",
    message: "入力された名前は空白にできません。",
    placeholder: "ユーザー名を入力してください",
    Reset: "パスワードをリセット",
    Resets:
      "パスワードをリセットできます。6桁以上の数字とパスワードを入力してください",
    ResetPas: "パスワードをリセット",
    Delete: "アカウント削除",
    Deletes:
      "これにより、アカウントとそのすべてのデータが永久に削除され、再度アクティブにすることはできません。",
    sure: "Fineshareアカウントを削除してもよろしいですか？",
    sures:
      "アカウントが削除されると、Fineshare上のすべてのデータが永久に削除されます。アカウント削除を進めるために、確認コードをお送りしました。コードを入力して「確認」をクリックしてください。",
    Deletebtn: "削除",
    Deleteplaceholder: "6桁の確認コードを入力してください",
  },
  order: {
    Order: "私の注文",
    history: "注文履歴はこのページに記録されています",
    dont: "まだ製品はありません",
    Buy: "今すぐ購入して最適化をさらに受け取るには、下のボタンをクリックして今すぐ手に入れてください",
    BuyBtn: "今すぐ購入",
    OrderId: "注文ID：",
    Price: "価格：",
    Date: "注文日：",
  },
  Product: {
    Product: "私の製品",
    products: "あなたのアカウントにログインしている製品",
    dont: "まだ製品はありません",
    Management: "デバイス管理 >",
  },
  redeem: {
    Redeem: "メンバーシップを交換",
    products: "ここで Fineshare の製品を交換できます",
    Please: "交換コードを入力してください",
    placeholder: "交換コード",
    Submit: "送信",
    Notes: "注意事項：",
    Notes1: "1. 交換コードの形式：XXXXX；",
    Notes2:
      "2. 交換した製品を表示するには、「製品」メニューをクリックしてください。",
    Successfully: "交換成功",
    Follow: "以下の手順に従って VoiceTrans の使用を開始してください：",
    step1: "1. Fineshare VoiceTrans をダウンロードしてインストールします。",
    step2: "2. VoiceTrans を開き、",
    Account: "アカウント",
    step3:
      "3. メールアドレスとパスワードを入力して Fineshare アカウントにサインインします。",
    Tips: "ヒント：より良い使用のために、",
    guide: "ガイド",
    Redemption: "交換失敗",
    redeemed:
      "交換コードはすでに使用されました。ソフトウェアを開き、アカウントに再度ログインして使用を開始してください。",
    Failed: "交換失敗",
    check: "交換コードを確認してください。",
  },
  details: {
    Product: "私の製品",
    products: "購入したすべての製品がこのページに表示されます",
    Back: "リストに戻る",
    Name: "デバイス名",
    system: "デバイスシステム",
    status: "デバイス状態",
    Operation: "操作",
    Delete: "削除",
    contact:
      "現在、直接デバイスの削除はサポートされていません。デバイスを削除する必要がある場合は、以下の方法でお問い合わせください：",
  },
  nav: {
    Home: "ホーム",
    Account: "アカウント",
    Order: "注文",
    Product: "製品",
    Redeem: "引き換え",
    Help: "ヘルプセンター",
  },
  auth: {
    Authorization: "認証に成功しました！",
    wait: "アプリに戻りますので、少々お待ちください...",
  },
  notfound: {
    Not: "ページが見つかりません",
    Unfortunately:
      "申し訳ありませんが、探しているページは存在しないか、入力したリンクにエラーがあります。",
    Home: "ホームに戻る",
  },
  topuser: {
    Settings: "アカウント設定",
    language: "言語",
    Logout: "ログアウト",
  },
  loginweb: {
    Conversion: "変換が間もなく開始されます",
    currently: "現在、待機中の人数は ",
    people: "人です！",
    Please:
      "ログインしてください。変換が完了した後、結果をメールでお送りします。",
    dont: "ログインしたくない",
  },
  mobilelogin: {
    Welcome: "Fineshareへようこそ！始めるにはログインしてください。",
  },
  reset: {
    Reset: "新しいパスワードをリセットする",
    Password:
      "パスワードは6文字以上で、少なくとも1つのアルファベットと1つの数字を含める必要があります。",
    password: "新しいパスワードを入力してください",
    Back: "ログインに戻る",
    Congratulations: "おめでとうございます！",
    successfully:
      "パスワードが正常にリセットされました。すぐにログインを開始できます。",
    Login: "ログイン",
    Please: "6桁の数字と文字を入力してください",
    failed:
      "パスワードリセットに失敗しました。メールのリセットリンクをクリックしてください。",
  },
  verification: {
    verification: "確認コードを入力してください",
    haveverification: "確認コードを送信しました：",
    Please: "下に受け取った確認コードを入力してください：",
    Enter: "6桁の確認コードを入力してください",
    Resend: "確認コードを再送信",
    Wait: "再送信まで ",
    again: "秒待機してください",
    Verify: "確認",
    error: "確認コードエラー",
    verificationcode: "確認コードを入力してください",
  },
};
